const IMAGE_MIME_PREFIX = 'image/';
const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'heic', 'heif', 'avif'];

const extensionFromValue = (value?: string): string => {
  if (!value) return '';
  const withoutQuery = value.split('#')[0].split('?')[0];
  const base = withoutQuery.split('/').filter(Boolean).pop() || '';
  const dotIndex = base.lastIndexOf('.');
  if (dotIndex < 0) return '';
  return base.slice(dotIndex + 1).toLowerCase();
};

/**
 * Decides whether a support attachment should be rendered as an image.
 * Uses the mimetype when available and falls back to the file extension
 * (Trello-imported attachments may not carry a mimetype).
 */
const isImageAttachment = (attachment: { mimetype?: string; name?: string; url?: string }): boolean => {
  const mimetype = (attachment?.mimetype || '').toLowerCase();
  if (mimetype.startsWith(IMAGE_MIME_PREFIX)) return true;

  const extension = extensionFromValue(attachment?.name) || extensionFromValue(attachment?.url);
  return IMAGE_EXTENSIONS.includes(extension);
};

export default isImageAttachment;
